import './styles/teachers.css'
import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import AddTeacher from '../components/addteacher'
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { arrayUnion, collection, doc, getDocs, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { auth, db } from '../assets/connections'
import { generateKey, validateEmail } from '../assets/validator'
import { createUserWithEmailAndPassword } from 'firebase/auth'

const Teachers = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        loading: true,
        teachers: [],
        sedes: [],
        teacher: {
            nombre_profesor: "",
            apellido_p_profesor: "",
            correo_profesor: "",
            clave_profesor: "",
            academia_profesor: [academia]
        },
        modal: false
    })

    //Variables del control de los datos del nuevo profesor
    const [ addTeacher, setAddTeacher ] = useState({
        show: false,
        nombre_profesor: "",
        apellido_p_profesor: "",
        correo_profesor: "",
        clave_profesor: "",
        academia_profesor: [academia],
        sedes_seleccionadas: []
    })

    //Funciones para agregar al profesor
    const onHandleAgregar = () => {
        if(validarFormulario()){
            setAddTeacher(prev => ({
                ...prev,
                show: false
            }))
            addPlayer()
        }
    }
    const validarFormulario = () => {
        if(addTeacher.nombre_profesor && addTeacher.apellido_p_profesor && addTeacher.correo_profesor){
            if(validateEmail(addTeacher.correo_profesor)){

                let nombre = addTeacher.nombre_profesor.trim()
                let apellido = addTeacher.apellido_p_profesor.trim()
                let correo = addTeacher.correo_profesor.trim()

                setAddTeacher(prev => ({
                    ...prev,
                    nombre_profesor: nombre,
                    apellido_p_profesor: apellido,
                    correo_profesor: correo
                }))

                return true

            } else {
                showMessage("Debes agregar un correo valido", "warning")
            }
        } else {
            showMessage("Debes completar todos los campos", "warning")
        }
        return false
    }
    const addPlayer = () => {
        //Validamos que el profesor no este en la misma academia
        var cont = 0
        for(let i = 0; i < variables.teachers.length; i++){
            if(addTeacher.correo_profesor == variables.teachers[i].id){
                cont ++
            }
        }
        if(cont == 0){
            setVariables(prev => ({
                ...prev,
                loading: true
            }))
            addingPlayer()
        } else {
            showMessage("El profesor ya esta registrado", "warning")
        }
    }
    const addingPlayer = async () => {
        await createUserWithEmailAndPassword(auth, addTeacher.correo_profesor, addTeacher.clave_profesor).then(r => {
            var newTeacher = { ...addTeacher }
            delete newTeacher.show
            delete newTeacher.sedes_seleccionadas
            if(addTeacher.sedes_seleccionadas && addTeacher.sedes_seleccionadas.length > 0){
                newTeacher.sedes_profesor = { [academia]: addTeacher.sedes_seleccionadas }
            }
            setDoc(doc(db, "Profesores", addTeacher.correo_profesor), newTeacher).then(r => {
                setAddTeacher(prev => ({
                    ...prev,
                    show: false,
                    nombre_profesor: "",
                    apellido_p_profesor: "",
                    correo_profesor: "",
                    clave_profesor: "",
                    sedes_seleccionadas: []
                }))
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Profesor registrado", "success")
                }, 100)
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error de conexion", "error")
                }, 100)
            })
        }).catch(e =>{
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            if(e.code == "auth/email-already-in-use"){
                console.log(addTeacher)
                var updateData = {
                    academia_profesor: arrayUnion(addTeacher.academia_profesor[0])
                }
                if(addTeacher.sedes_seleccionadas && addTeacher.sedes_seleccionadas.length > 0){
                    updateData["sedes_profesor." + academia] = addTeacher.sedes_seleccionadas
                }
                updateDoc(doc(db, "Profesores", addTeacher.correo_profesor), updateData).then(r => {
                    setAddTeacher(prev => ({
                        ...prev,
                        show: false,
                        nombre_profesor: "",
                        apellido_p_profesor: "",
                        correo_profesor: "",
                        clave_profesor: "",
                        sedes_seleccionadas: []
                    }))
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("Profesor registrado", "success")
                    }, 100)
                }).catch(e => {
                    console.log(e.code + " " + e.message)
                    setVariables(prev => ({
                        ...prev,
                        loading: false
                    }))
                    setTimeout(() => {
                        showMessage("Error de conexion", "error")
                    }, 100)
                })
            } else {
                setTimeout(() => {
                    showMessage("Error de conexion", "error")
                }, 100)
            }
        })
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            // Cargar sedes
            getDocs(collection(doc(db, ref), "Sedes")).then(sedesSnap => {
                var sedesAux = []
                sedesSnap.docs.forEach(v => {
                    sedesAux.push({ id: v.id, nombre_sede: v.data().nombre_sede })
                })
                setVariables(prev => ({ ...prev, sedes: sedesAux }))
            }).catch(() => {})

            onSnapshot(query(collection(db, "Profesores"), where("academia_profesor", "array-contains", academia)), queryProfesores => {
                var aux = []
                queryProfesores.docs.map(v => {
                    var newObject = {
                        ...v.data(),
                        id: v.id
                    }
                    aux.push(newObject)
                })

                setVariables(prev => ({
                    ...prev,
                    teachers: aux,
                    loading: false
                }))

            })
        }
    }, [])

    if(variables.loading){
        return (
            <Loader
                loading={variables.loading}
            />
        )
    }

    if(!variables.loading)
    return (
        <div className='mainTeachers'>

            <Snack />

            <AddTeacher
                addTeacher={addTeacher}
                setAddTeacher={setAddTeacher}
                onHandleAdd={onHandleAgregar}
                sedes={variables.sedes}
            />

            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>PROFESORES</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -50,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ? 
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <button className='addTeacher' style={{
                backgroundColor: main,
                color: "white",
                fontFamily: fontType.subTitle,
                fontSize: "18px"
            }} onClick={() => {
                setAddTeacher(prev => ({
                    ...prev,
                    clave_profesor: generateKey(),
                    show: true
                }))
            }}>AGREGAR PROFESOR</button>

            <div className='contTeachers'>
                {
                    variables.teachers.map((v, i) => {
                        return (
                            <Link to={"/teachers/teacher"} state={{
                                ref: ref,
                                data: v,
                                academia: academia
                            }} className='teacher' style={{
                                borderColor: main,
                                color: "black",
                                textDecoration: "none"
                            }}>
                                <p style={{
                                    fontFamily: fontType.text,
                                    fontWeight: 700,
                                    fontSize: 18
                                }}>{v.nombre_profesor} {v.apellido_p_profesor}</p>
                            </Link>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Teachers